/**
 * @generated SignedSource<<87267b3f887dec9eb1de07e3b973e953>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FileUploadAreaWorkspace_workspace$data = {
  readonly id: string;
  readonly " $fragmentType": "FileUploadAreaWorkspace_workspace";
};
export type FileUploadAreaWorkspace_workspace$key = {
  readonly " $data"?: FileUploadAreaWorkspace_workspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"FileUploadAreaWorkspace_workspace">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FileUploadAreaWorkspace_workspace",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};

(node as any).hash = "5fdb0a0bf3521e140696ba1a1331ae06";

export default node;
